//
//  loading-overlay.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Vue, Component } from 'vue-property-decorator';
import lottie from 'lottie-web';
import { mapState } from 'vuex';

@Component({
    computed: {
        ...mapState('dataModule', ['backgroundUrl']),
    },
})
export default class LoadingOverlay extends Vue {

    private backgroundUrl!: string;

    private get overlay(): HTMLElement {

        return this.$refs.overlay as HTMLElement;

    }

    private mounted(): void {

        this.setOverlayLogoBackground();
        this.setLoadingAnimation();

    }

    /*
     * Set random dynamic background.
     */
    private setOverlayLogoBackground(): void {

        const url: string = this.backgroundUrl;

        this.overlay.style.background = `url('/image/background/${url}/${url}.png')`;
        this.overlay.style.backgroundSize = 'cover';


    }

    /*
     * Load the lottie loading animation.
     */
    private setLoadingAnimation(): void {

        lottie.loadAnimation({
            container: this.$refs.loader as HTMLElement, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/image/lottie/loader.json', // the path to the animation json
        });

    }

}
